export default {"src":"/_next/static/media/F.41f28fd9.svg","height":18,"width":18};